import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon/Icon'
import './Counter.scss'
class Counter extends React.Component {
  state = { value: '' }
  componentDidUpdate(prevProps) {
    if (prevProps.counterValue !== this.props.counterValue) {
      this.setState({ value: this.props.counterValue })
    }
  }
  componentDidMount() {
    this.setState({ value: this.props.counterValue })
  }
  handleInputValue = e => {
    const numericValue = parseInt(e.target.value, 10) || 0
    this.props.handleChange(this.props.name, numericValue)
  }

  /*
   * Increases or decreases the counter value and passes to the parent component
   * @param {number} step
   */
  countValue = step => {
    const steppedValue = this.props.counterValue + step
    this.props.handleChange(this.props.name, steppedValue)
  }

  handleFocus = () => {
    this.setState({ value: '' })
  }

  handleBlur = () => {
    this.setState({ value: this.props.counterValue })
  }
  render() {
    const {
      counterValue,
      step,
      minValue,
      maxValue,
      name,
      id,
      label,
      required,
      hint,
      customClassName,
      iconName,
    } = this.props
    /**
     * Passes the inputed value to the parent component
     * @param {Object} e
     */

    return (
      <section className={`Counter ${customClassName}`}>
        <label className="Counter__label">
          {iconName && <Icon name={iconName} />}
          <strong>{label}</strong>
          <br />
          <small>{hint}</small>
        </label>
        <div className="Counter__container">
          <button
            className="Counter__button subtract"
            disabled={counterValue <= minValue || counterValue <= 0}
            onClick={e => {
              this.countValue(-step)
              e.preventDefault()
            }}
          >
            <Icon name="minus" />
          </button>
          <input
            type="number"
            className="Counter__input"
            value={this.state.value}
            step={step}
            min={minValue}
            max={maxValue}
            onChange={this.handleInputValue}
            onBlur={this.handleBlur}
            name={name}
            onFocus={this.handleFocus}
            id={id}
            required={required}
          />
          <button
            className="Counter__button add"
            disabled={counterValue >= maxValue}
            onClick={e => {
              this.countValue(step)
              e.preventDefault()
            }}
          >
            <Icon name="add" />
          </button>
        </div>
      </section>
    )
  }
}

Counter.propTypes = {
  counterValue: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  customClassName: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  iconName: PropTypes.string,
}

export default Counter
